import React from "react";
import { svg } from "../../../../../Assets/svg";
import { Modal } from "antd";
import { RootState, useAppSelector } from "../../../../../store";
import { BtnLoader } from "../../../../../Components/Components";

const ReloadPrifieldDataConfirmationModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: any;
  handleSucess: any;
}> = ({
  visible,
  setIsModalVisible,
  onClose,
  handleSucess,
}) => {
  const { prefillProductionPlanningLoading } = useAppSelector(
    (state: RootState) => state.loading,
  );
  return (
    <Modal
      title={
         <div className="text-center fs-4 fw-bolder lh-m">
          Reassign Production Plan Details, Are You Sure?
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
            disabled={prefillProductionPlanningLoading}
          >
            CLOSE
          </button>
          <button
            type="submit"
            form="submitCreateMAchin"
            disabled={prefillProductionPlanningLoading}
            className={`btn btn-lg min-w-130 btn-primary`}
            onClick={handleSucess}
          >
            {prefillProductionPlanningLoading ? (
              <BtnLoader />
            ) : (
              "YES, REASSIGN"
            )}
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        <p className="fs-6 d-flex justify-content-center mt-3 text-center text-4a4a4a">
          After reassign production plan details, the system will attempt to pre-fill any missing machine and department details using the available information. You can modify them later if needed.
        </p>
      </div>
    </Modal>
  );
};

export default ReloadPrifieldDataConfirmationModal;
